import {createFeatureSelector, createSelector} from "@ngrx/store";
import {ITourSectionState} from "../reducers/tour-section.reducer";
import {DbStoreState} from "../reducers";

const getDbStoreState = createFeatureSelector<DbStoreState>('dbStore');
export const getTourSectionState = createSelector(getDbStoreState, (dbStoreState: DbStoreState) => dbStoreState.tourSection);

export const getTourSectionToggled = createSelector(getTourSectionState,
  (state: ITourSectionState) =>
    state.toggled
);
